export const VatEnum = {
    KIT: 'kit',
    DELIVERY: 'delivery',
};
